<script>
  import {onMount, onDestroy} from "svelte";
  import {user} from "./stores";
  import {redirectToPage, getApiUrl, fetchWithSession} from "./util";
  import {createEventDispatcher} from "svelte";

  import InputField from "./components/InputField.svelte";
  import SubmitButton from "./components/SubmitButton.svelte";

  const dispatch = createEventDispatcher();

  let context = "signin";
  let isResetVerifySent = false;
  let isSignupVerifySent = false;
  let isLoading = false;

  console.debug("user: ", $user);
  export let userData;
  $: {
    userData = $user;
  }
  let isAuth;
  $: {
    isAuth = $user.isAuth;
    console.debug("isAuth: ", isAuth);
  }
  console.debug("userData: ", userData);
  let username = userData.username ? userData.username : "";
  let password = "";
  let email = userData.email ? userData.email : "";
  let passwordConfirm = "";
  let rememberMe = true;

  let successMsg = "";
  let errMsg = "";
  let errMsgs = {};

  const resetAll = () => {
    successMsg = "";
    errMsg = "";
    errMsgs = {};
    isResetVerifySent = false;
    isSignupVerifySent = false;
    isLoading = false;
    console.debug("resetAll");
  };

  function setErrMsgs(field = null, msg = "", msgTop = undefined) {
    successMsg = null;
    if (msgTop !== undefined) {
      errMsg = msgTop;
    }
    if (field === null) {
      for (const key in errMsgs) {
        errMsgs[key] = null;
      }
      return;
    } else {
      errMsgs[field] = msg;
    }
  }

  function handleInput(field) {
    return () => {
      successMsg = null;
      isSignupVerifySent = $user.username === username && $user.email === email;
      setErrMsgs(field, "", "");
    };
  }

  async function handleErrors(res) {
    const {errors, error} = await res.json();
    if (errors || error) {
      const errorArr = errors ? errors : [{msgTop: error}];
      console.debug(errorArr);
      setErrMsgs(null, "", "");
      errorArr.forEach(({field, msg, msgTop}) => {
        setErrMsgs(field, msg, msgTop);
      });
    }
  }

  function toggleTheme() {
    document.documentElement.classList.toggle("dark-mode");
  }

  async function handleSignUp() {
    if (password !== passwordConfirm) {
      errMsgs.passwordConfirm = "Passwords do not match";
      return;
    }
    isLoading = true;
    let res;
    if (!isSignupVerifySent) {
      res = await fetch(getApiUrl("signup", null, "users"), {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({username, email, password})
      });
    } else {
      res = await fetch(getApiUrl("signup/resend", null, "users"), {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({username, email, password})
      });
    }
    isLoading = false;
    if (res.ok) {
      user.update((u) => {
        return {...u, username, email};
      });
      const data = await res.json();
      console.debug(data);
      successMsg = data.message ? data.message : "Account created successfully. Please check your email for verification.";
      isSignupVerifySent = true;
    } else {
      handleErrors(res);
    }
  }

  async function handleSignIn() {
    const apiurl = getApiUrl("signin", null, "users");
    isLoading = true;
    try {
      const res = await fetch(apiurl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({id: username, password, rememberMe}),
        credentials: "include"
      });
      console.log(JSON.stringify({id: username, password, rememberMe}))
      console.log("full response:", res)
      if (res.ok) {
        console.debug("user: ", $user);
        const data = await res.json();
        console.debug(data);
        user.update((u) => {
          return {...u, username, email: data.email, role: data.role, isAuth: true};
        });
        console.debug("user: ", $user);
        redirectToPage("flderrs");
        console.debug("redirected");
      } else {
	//console.log	
        handleErrors(res);
      }
    } catch (err) {
      console.debug("error handling sign in error: ", err);
      setErrMsgs(null, null, "Connection refused. Please try again later or contact the administrator.");
    }
    isLoading = false;
  }

  async function handleForgotPasswordVerify() {
    setErrMsgs(null, null, "");
    isLoading = true;
    user.update((user) => ({...user, email}));
    try {
      const res = await fetch(getApiUrl("forgot", null, "users"), {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({email})
      });
      isLoading = false;
      if (res.ok) {
        successMsg = "Verification code sent to email";
        isResetVerifySent = true;
      } else {
        handleErrors(res);
      }
    } catch (err) {
      console.debug(err);
    }
  }

  onMount(() => {
    document.querySelector("header").style.display = "none";
    if (isAuth) {
      document.querySelector("header").style.display = "flex";
      redirectToPage("flderrs");
    }
  });

  onDestroy(() => {
    document.querySelector("header").style.display = "flex";
  });
</script>

{#if !isAuth}
  <header>
    FDMF Error Management

    <!-- add a light/dark theme switch -->
    <!-- <label class="theme-switch">
    <input type="checkbox" on:change={toggleTheme} />
    <span class="slider round" />
  </label> -->
  </header>
{/if}

<main class="login-container">
  <div class="card">
    <nav>
      <ul>
        <li
          class:tab-active={context === "signin"}
          on:click={() => {
            context = "signin";
            resetAll();
          }}>
          Sign In
        </li>
        <li
          class:tab-active={context === "signup"}
          on:click={() => {
            context = "signup";
            resetAll();
          }}>
          Sign Up
        </li>
      </ul>
    </nav>
    {#if errMsg || successMsg}
      <div class={errMsg ? "error-message" : "success-message"}>
        {errMsg ? errMsg : successMsg}
      </div>
    {/if}

    <!--------------------- Signin Form --------------------->
    {#if context === "signin"}
      <form on:submit|preventDefault={handleSignIn}>
        <InputField label={"Username or Email"} id="username" bind:value={username} {handleInput} {errMsgs} />
        <InputField label={"Password"} id="password" bind:value={password} {handleInput} {errMsgs} enterEvent={handleSignIn} />
        <div class="row" id="remember-row">
          <div class="checkbox left-item">
            <input type="checkbox" id="remember" bind:checked={rememberMe} />
            <label for="remember">Remember me</label>
          </div>
          <a
            class="right-item"
            on:click={() => {
              context = "reset-password";
              setErrMsgs(null, null, "");
            }}>
            Reset password
          </a>
        </div>
        <SubmitButton {isLoading} label="Sign In" />
      </form>
      <!-------------------- Signup Form -------------------->
    {:else if context === "signup"}
      <form on:submit|preventDefault={handleSignUp}>
        <InputField label={"Username"} id="username" bind:value={username} {handleInput} {errMsgs} />
        <InputField label={"Email"} id="email" bind:value={email} {handleInput} {errMsgs} />
        <InputField label={"Password"} id="password" bind:value={password} {handleInput} {errMsgs} />
        <InputField label={"Confirm Password"} id="passwordConfirm" bind:value={passwordConfirm} {handleInput} {errMsgs} />
        <SubmitButton {isLoading} label={isSignupVerifySent ? "Resend Verification Email" : "Create Account"} />
      </form>
      <!---------------- Reset Password Form ---------------->
    {:else if context === "reset-password"}
      {#if !isResetVerifySent}
        <form on:submit|preventDefault={handleForgotPasswordVerify}>
          <InputField label={"Email"} id="email" bind:value={email} {handleInput} {errMsgs} />
          <SubmitButton {isLoading} label={"Get Reset Link"} />
        </form>
        <!------------ Reset Password Email Sent ------------>
      {:else if isResetVerifySent}
        <form on:submit|preventDefault={handleForgotPasswordVerify}>
          <p>Please check your email for a link to verify your account.</p>
          <SubmitButton {isLoading} label={"Resend Verification Email"} />
        </form>
      {/if}
    {/if}
  </div>
</main>

<style>
  header {
    position: fixed;
    color: #111;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    justify-content: space-between;
    background-color: var(--color-surface);
    border: 1px solid #e7e7e7;
    border-radius: 5px;
    padding: 1.5rem;
    font-size: 2em;
    font-weight: 600;
    color: #555;
    z-index: 1 !important;
  }
</style>
